import InkTextInput from 'ink-text-input';
import React from 'react';

const TextInput = ({ onBlur, onFocus, ...props }: TextInputProps) => {
  React.useEffect(() => {
    onFocus();
    return onBlur;
  }, [onFocus, onBlur]);
  return <InkTextInput {...props} showCursor />;
};

export default TextInput;

type InkTextInputProps = React.ComponentProps<typeof InkTextInput>;
interface TextInputProps extends InkTextInputProps {
  onBlur: () => void;
  onFocus: () => void;
}
